/**
 * Wrapper for fetch to automatically attach Bearer token to same-origin API calls.
 * @param {string} url - The request URL (relative or absolute).
 * @param {object} options - Fetch options (method, headers, body, etc.).
 */
/**
 * Wrapper for fetch to automatically attach Bearer token and backend URL to API calls.
 * If URL starts with '/api', prefix with VITE_BACKEND_URL (sans trailing /api).
 */
export default async function apiFetch(url, options = {}) {
  // Determine absolute URL for API endpoints
  const envBase = import.meta.env.VITE_BACKEND_URL || '';
  // Remove trailing '/api' if present
  const backend = envBase.replace(/\/api\/?$/, '');
  let fullUrl = url;
  if (url.startsWith('/')) {
    fullUrl = backend + url;
  }
  // Attach auth header
  const opts = { ...options };
  const headers = new Headers(opts.headers || {});
  const token = localStorage.getItem('token');
  if (token) headers.set('Authorization', `Bearer ${token}`);
  opts.headers = headers;
  return fetch(fullUrl, opts);
}